import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useI18n } from 'components/I18n';
import { MENU_ICON_SIZE } from './navigationUtils';
import { Box } from 'components';
import AvatarImage from '../../ProfilesView/AvatarImage';
import { StyledProfileAvatar } from './Styles';
import { SettingsIcon } from 'components/Icons';
import { useProfileContext } from '../../ProfilesView/ProfileContext';
import { DROPDOWN_TRIGGER_CLASS } from './MenuDropdown';

function UserProfile() {
  const i18n = useI18n();
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const isAnonymousUser = useSelector(state => state.auth.isAnonymousUser);
  const { currentProfile, isFeatureEnabled } = useProfileContext();
  const avatarImageUrl = currentProfile?.imageUrl;
  const avatarName = currentProfile?.name;
  const avatarSize = MENU_ICON_SIZE;

  if (!isLoggedIn || isAnonymousUser) {
    return null;
  }

  return (
    <StyledProfileAvatar
      className={DROPDOWN_TRIGGER_CLASS}
      data-cy="user-profile"
      tabIndex="0"
      role="button"
      aria-label={avatarName || i18n.formatText('settings')}
    >
      <Box
        position="relative"
        width={avatarSize}
        height={avatarSize}
        borderRadius="100"
        display="flex"
        alignItems="center"
        justifyContent="center"
        hideEmpty={false}
        style={{
          boxSizing: 'border-box',
        }}
        suppressHydrationWarning
      >
        {isFeatureEnabled && (
          <AvatarImage
            src={avatarImageUrl}
            size={avatarSize}
            hidden={false}
            alt={avatarName}
          />
        )}
        {!isFeatureEnabled && <SettingsIcon size={avatarSize} />}
      </Box>
    </StyledProfileAvatar>
  );
}

UserProfile.propTypes = {};

export default React.memo(UserProfile);


